import { render, staticRenderFns } from "./Page8Chart.vue?vue&type=template&id=94a7db74&scoped=true&"
import script from "./Page8Chart.vue?vue&type=script&lang=ts&"
export * from "./Page8Chart.vue?vue&type=script&lang=ts&"
import style0 from "./Page8Chart.vue?vue&type=style&index=0&id=94a7db74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a7db74",
  null
  
)

export default component.exports